import {abbreviateNumber} from 'common/util';

import {Bucket, BucketType} from '../types';

const abbreviate = (num) => abbreviateNumber(num, {precision: 2, trimZeroes: true});

export function getBucketType(bucket: Bucket): BucketType {
  return bucket.disabled ? BucketType.None : bucket.groups ? BucketType.Varied : BucketType.Even;
}

export function getUnevenBucketPreview(groups: number[]) {
  const inner = [...groups]
    .splice(1)
    .map((_, idx) => `${abbreviate(groups[idx])}-${abbreviate(groups[idx + 1])}, `)
    .join(``);

  // Should look like "<10, 10-20, 20-30, >=30"
  return groups.length ? `<${abbreviate(groups[0])}, ${inner}>=${abbreviate(groups[groups.length - 1])}` : `N/A`;
}

export function getEvenBucketPreview(min: number, max: number, binSize: number) {
  // the real max is actually going to be greater if the bin doesnt go in evenly
  // for example min and max of 0 and 6 with a bucket size of 5 will have 0-5, 5-10, 10+ buckets
  // TODO change this if the backend logic changes
  const binOverflow = (max - min) % binSize;
  const realMax = binOverflow ? max - binOverflow + binSize : max;
  const previewList = [`<${abbreviate(min)}`];
  let entryCount = 0;
  const pushBucket = () =>
    previewList.push(`${abbreviate(min + binSize * entryCount)}-${abbreviate(min + binSize * ++entryCount)}`);
  // add inner buckets depending on if the buckets exist, with an extra bucket when dealing with values with less than 3 digits
  // example output: "<0, 0-30, 30-60, 60-90, ..., ≥120"
  const range = realMax - min;
  range !== 0 && pushBucket();
  range >= binSize * 2 && pushBucket();
  range >= binSize * 3 && min + binSize * 3 < 100 && pushBucket();
  min + binSize * entryCount < realMax && previewList.push(`...`);
  previewList.push(`≥${abbreviate(realMax)}`);
  return previewList.join(`, `);
}

export function getBucketPreview(bucket: Bucket) {
  switch (getBucketType(bucket)) {
    case BucketType.None:
      return `1, 2, 3, 4, 5, ..., 100, ...`;
    case BucketType.Varied:
      return getUnevenBucketPreview(bucket.groups);
    case BucketType.Even:
      return getEvenBucketPreview(bucket.min, bucket.max, bucket.bucketSize);
  }
}
